import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OuiDialogService } from 'omnium-ui/dialog';
import { OperationStateTransitionTrigger } from 'projects/box-lib/src/public-api';
import { TransmissionCourrierDialogComponent } from './transmission-courrier-dialog/transmission-courrier-dialog.component';

export enum TransferType {
  courrier = 'courrier',
  email = 'email',
  extranet = 'extranet',
  direct = 'direct',
}

@Component({
    selector: 'lib-transmission-partenaire-dialog',
    templateUrl: './transmission-partenaire-dialog.component.html',
    styleUrls: ['./transmission-partenaire-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TransmissionPartenaireDialogComponent {
  protected transfertTypeEnum = TransferType;

  transfertType?: TransferType;
  operationId?: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: { operationId?: number },
    private dialogRef: MatDialogRef<TransmissionPartenaireDialogComponent>,
    private dialogService: OuiDialogService
  ) {
    this.operationId = data.operationId;
  }

  openTransmissionCourrierDialog() {
    const modalRef = this.dialogService.openDialog(TransmissionCourrierDialogComponent, undefined, 'auto', '492px');
    modalRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.dialogRef.close(OperationStateTransitionTrigger.GestionnaireTransfersOperationToPartenaireByCourrier);
      }
    });
  }

  onTransmissionModeSelected(transfer: TransferType) {
    if (transfer === TransferType.courrier) {
      this.dialogRef.close(OperationStateTransitionTrigger.GestionnaireTransfersOperationToPartenaireByCourrier);
    }

    this.transfertType = transfer;
  }

  onValidation(isSucces: boolean) {
    if (isSucces) {
      this.dialogRef.close(OperationStateTransitionTrigger.GestionnaireTransfersOperationToPartenaire);
    }
  }
}
